// import { CloseIcon, Star } from '@MerchantConfigurator/components/common';
import {
  DynamicLayoutBlocks,
  MobileThemeColors,
  PreviewModes,
  previewSectionSizes,
  PreviewThemeColors
} from '@MerchantConfigurator/constants';

// basic container with default styles
export const getContainer = (props) => {
  const container = {
    type: DynamicLayoutBlocks.CONTAINER,
    style: {
      width: 'auto',
      height: 'auto',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'row',
      overflow: 'hidden',
      ...props?.style
    },
    className: props?.className
  };
  return container;
};

export const getHorizontalBars = ({ style = {}, number = 1 }) => {
  const headerBars = [];
  for (let i = 0; i < number; i++) {
    headerBars.push({
      type: DynamicLayoutBlocks.CONTAINER,
      style
    });
  }

  return headerBars;
};

export const getRatingStar = ({ number = 5 }) => {
  const ratingStars = [];
  for (let i = 0; i < number; i++) {
    ratingStars.push({
      type: DynamicLayoutBlocks.IMAGE,
      style: {},
      // src: Star
      src: 'https://www.paypalobjects.com/paypal-ui/icons/v5/svg/cash-back-sm.svg'
    });
  }
  return ratingStars;
};

export const getProductWithOneDescription = ({ darkMode, number }) => {
  const productDescriptions = [];

  for (let i = 0; i < number; i++) {
    productDescriptions.push({
      ...getContainer({
        style: {
          flexDirection: 'column',
          marginTop: previewSectionSizes.lg,
          alignItems: 'start'
        }
      }),
      blocks: [
        getContainer({
          style: {
            width: number > 3 ? previewSectionSizes['7xl'] : previewSectionSizes['6xl'],
            height: number > 3 ? previewSectionSizes['7xl'] : previewSectionSizes['6xl'],
            marginBottom: previewSectionSizes.md,
            backgroundColor: getBackgroundColor({
              darkMode,
              backgroundColor: 'componentsColor'
            })
          }
        }),
        ...getHorizontalBars({
          style: {
            width: previewSectionSizes['4xl'],
            height: previewSectionSizes.sm,
            backgroundColor: getBackgroundColor({
              darkMode,
              backgroundColor: 'componentsColor'
            })
          },
          number: 1
        })
      ]
    });
  }

  return productDescriptions;
};

export const getProductWithTwoDescriptions = ({ darkMode, number }) => {
  const productDescriptions = [];

  for (let i = 0; i < number; i++) {
    productDescriptions.push({
      ...getContainer({
        style: {
          alignItems: 'start',
          flexDirection: 'column',
          marginTop: number > 1 ? 0 : previewSectionSizes.lg
        }
      }),
      blocks: [
        getContainer({
          style: {
            backgroundColor: getBackgroundColor({
              darkMode,
              backgroundColor: 'componentsColor'
            }),
            height: previewSectionSizes['9xl'],
            marginBottom: previewSectionSizes.md,
            width: number > 1 ? previewSectionSizes['10xl'] : previewSectionSizes['14xl']
          }
        }),
        ...getHorizontalBars({
          style: {
            width: previewSectionSizes['4xl'],
            height: previewSectionSizes.sm,
            marginBottom: previewSectionSizes.md,
            backgroundColor: getBackgroundColor({
              darkMode,
              backgroundColor: 'componentsColor'
            })
          },
          number: 1
        }),
        ...getHorizontalBars({
          style: {
            width: previewSectionSizes['2xl'],
            height: previewSectionSizes.sm,
            backgroundColor: getBackgroundColor({
              darkMode,
              backgroundColor: 'componentsColor'
            })
          },
          number: 1
        })
      ]
    });
  }

  return productDescriptions;
};

export const getProductWithTwoDescriptionsAndTotal = ({ darkMode }) => {
  return {
    ...getContainer({
      style: {
        flexDirection: 'row',
        height: previewSectionSizes['6xl'],
        marginTop: previewSectionSizes.lg,
        alignItems: 'start'
      }
    }),
    blocks: [
      getContainer({
        style: {
          width: previewSectionSizes['6xl'],
          height: previewSectionSizes['6xl'],
          backgroundColor: getBackgroundColor({
            darkMode,
            backgroundColor: 'componentsColor'
          })
        }
      }),
      {
        ...getContainer({
          style: {
            height: previewSectionSizes['3xl'],
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'start',
            marginLeft: previewSectionSizes.lg,
            marginTop: previewSectionSizes.sm
          }
        }),
        blocks: [
          ...getHorizontalBars({
            style: {
              width: previewSectionSizes['4xl'],
              height: previewSectionSizes.xs,
              backgroundColor: getBackgroundColor({
                darkMode,
                backgroundColor: 'componentsColor'
              })
            },
            number: 1
          }),
          ...getHorizontalBars({
            style: {
              width: previewSectionSizes['2xl'],
              height: previewSectionSizes.xs,
              marginTop: previewSectionSizes.sm,
              marginBottom: previewSectionSizes.lg,
              backgroundColor: getBackgroundColor({
                darkMode,
                backgroundColor: 'componentsColor'
              })
            },
            number: 1
          }),
          ...getHorizontalBars({
            style: {
              width: previewSectionSizes['2xl'],
              height: previewSectionSizes.md,
              backgroundColor: getBackgroundColor({
                darkMode,
                backgroundColor: 'componentsColor'
              })
            },
            number: 1
          })
        ]
      }
    ]
  };
};

export const getProductWithTwoDescriptionsAndPrice = ({
  darkMode,
  price = 'right',
  containerWidth = 'auto',
  gap = previewSectionSizes.lg
}) => {
  return {
    //container
    ...getContainer({
      style: {
        flexDirection: 'row',
        height: previewSectionSizes['4xl'],
        marginTop: previewSectionSizes.xl,
        alignItems: 'start',
        gap,
        width: containerWidth
      }
    }),
    blocks: [
      //thumbnail - left side
      getContainer({
        style: {
          width: previewSectionSizes['4xl'],
          height: previewSectionSizes['4xl'],
          backgroundColor: getBackgroundColor({
            darkMode,
            backgroundColor: 'componentsColor'
          })
        }
      }),
      {
        //title1, title2 and total - right side
        ...getContainer({
          style: {
            height: previewSectionSizes['4xl'],
            flexDirection: 'column',
            justifyContent: 'Flex-end',
            alignItems: 'start',
            gap: previewSectionSizes.xs
          }
        }),
        blocks: [
          //title1
          ...getHorizontalBars({
            style: {
              width: previewSectionSizes['4xl'],
              height: previewSectionSizes.sm,
              backgroundColor: getBackgroundColor({
                darkMode,
                backgroundColor: 'componentsColor'
              })
            },
            number: 1
          }),
          //title2
          ...getHorizontalBars({
            style: {
              width: previewSectionSizes['2xl'],
              height: previewSectionSizes.sm,
              backgroundColor: getBackgroundColor({
                darkMode,
                backgroundColor: 'componentsColor'
              })
            },
            number: 1
          }),
          //price
          ...getHorizontalBars({
            style: {
              width: previewSectionSizes['2xl'],
              height: previewSectionSizes.md,
              marginTop: previewSectionSizes['2xl'],
              marginLeft: price === 'right' ? previewSectionSizes['4xl'] : '0px',
              backgroundColor: getBackgroundColor({
                darkMode,
                backgroundColor: 'componentsColor'
              })
            },
            number: 1
          })
        ]
      }
    ]
  };
};

export const getEstimatedTotalLine = ({
  darkMode,
  barWidth = previewSectionSizes['2xl'],
  marginRight = previewSectionSizes.xs
}) => {
  return [
    {
      type: DynamicLayoutBlocks.TEXT,
      style: {
        color: getBackgroundColor({
          darkMode,
          backgroundColor: 'componentsColor'
        }),
        marginRight
      },
      message: 'preview.total'
    },
    ...getHorizontalBars({
      style: {
        width: barWidth,
        height: previewSectionSizes.sm,
        backgroundColor: getBackgroundColor({
          darkMode,
          backgroundColor: 'componentsColor'
        })
      },
      number: 1
    })
  ];
};

export const horizontalLine = ({
  darkMode,
  width = '196px',
  marginTop = previewSectionSizes.lg
}) => {
  const borderColor = getBackgroundColor({
    darkMode,
    backgroundColor: 'componentsColor'
  });

  return getContainer({
    style: {
      width,
      marginTop,
      border: `1px solid ${borderColor}`
    }
  });
};

export const closeIconRow = ({ style = {} }) => ({
  ...getContainer({
    style
  }),
  blocks: [
    {
      type: DynamicLayoutBlocks.IMAGE,
      style: {
        height: '20px',
        width: '20px'
      },
      // src: CloseIcon,
      src: 'https://www.paypalobjects.com/paypal-ui/icons/v5/svg/close.svg'
    }
  ]
});

export const horizontalBarWithCurrency = ({ style = {}, darkMode, currencySymbol = '' }) => {
  return {
    ...getContainer({
      style
    }),
    blocks: [
      {
        type: DynamicLayoutBlocks.TEXT,
        style: {
          color: getBackgroundColor({
            darkMode,
            backgroundColor: 'componentsColor'
          }),
          marginRight: previewSectionSizes.xs
        },
        message: currencySymbol
      },
      {
        type: DynamicLayoutBlocks.CONTAINER,
        style
      }
    ]
  };
};

export const getBackgroundColor = ({
  darkMode = true,
  backgroundColor = 'backgroundMainColor',
  previewMode
}) => {
  if (previewMode === PreviewModes.mobile) {
    return MobileThemeColors[darkMode ? 'dark' : 'light'][`${backgroundColor}`];
  } else {
    return PreviewThemeColors[darkMode ? 'dark' : 'light'][`${backgroundColor}`];
  }
};
